export const REPORTING_LANDING_TABS = [
  "reports",
  "dashboards",
  "datasources",
] as const;

export type ReportingLandingTab = (typeof REPORTING_LANDING_TABS)[number];

/** Whitelists a raw `?tab=` search value; anything else is dropped. */
export function parseReportingLandingTab(
  value: unknown,
): ReportingLandingTab | undefined {
  return REPORTING_LANDING_TABS.find((tab) => tab === value);
}

/**
 * The tab to show. A group-access deep link always lands on Reports (that is
 * where the report list and its Group Access sheet live), and a requested tab
 * the person cannot see falls back to Reports rather than rendering empty.
 */
export function resolveReportingLandingTab({
  requested,
  hasGroupAccessLink,
  canSeeDashboards,
  canSeeDatasources,
}: {
  requested: ReportingLandingTab | undefined;
  hasGroupAccessLink: boolean;
  canSeeDashboards: boolean;
  canSeeDatasources: boolean;
}): ReportingLandingTab {
  if (hasGroupAccessLink) return "reports";
  if (requested === "dashboards" && canSeeDashboards) return "dashboards";
  if (requested === "datasources" && canSeeDatasources) return "datasources";
  return "reports";
}
